/** @jsxImportSource @emotion/react */
import { AddOutlined, CloudOffOutlined } from '@mui/icons-material'
import { Button } from '@mui/material'
import { ReactNode } from 'react'
import {
  containerStyles,
  descriptionStyles,
  iconWrapperStyles,
  titleStyles,
} from './EmptyData.styles'

export interface EmptyDataProps {
  icon?: ReactNode
  title: string
  description?: string
  actionLabel?: string
  onAction?: () => void
  maxWidth?: number | string
  showButton?: boolean
  buttonIcon?: ReactNode
  borderColor?: 'primary' | 'secondary' | 'neutral'
}

export const EmptyData = ({
  icon = <CloudOffOutlined fontSize="large" />,
  title,
  description,
  actionLabel,
  onAction,
  showButton = true,
  buttonIcon = <AddOutlined />,
  borderColor,
}: EmptyDataProps) => {
  return (
    <div css={() => containerStyles(borderColor)}>
      <div css={iconWrapperStyles}>{icon}</div>
      <h3 css={titleStyles}>{title}</h3>
      {description && <p css={descriptionStyles}>{description}</p>}
      {actionLabel && onAction && showButton && (
        <Button startIcon={buttonIcon} variant="contained" size="small" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  )
}
